/**
 * Query keys.
 *
 * One convention, so that invalidation works across screens written by different
 * people: `[resource, scope?, id?, params?]`, resource first, always an array.
 *
 *   qk.list('cases', { status: 'open' })   -> ['cases', 'list', { status: 'open' }]
 *   qk.detail('cases', id)                 -> ['cases', 'detail', id]
 *
 * Invalidating `['cases']` therefore clears every list and every detail for cases,
 * which is what you almost always want after a write.
 */

export type QueryParams = Record<string, unknown> | undefined;

export const qk = {
  all: (resource: string) => [resource] as const,
  list: (resource: string, params?: QueryParams) => [resource, 'list', params ?? {}] as const,
  infinite: (resource: string, params?: QueryParams) =>
    [resource, 'infinite', params ?? {}] as const,
  detail: (resource: string, id: string) => [resource, 'detail', id] as const,
  sub: (resource: string, id: string, child: string, params?: QueryParams) =>
    [resource, 'detail', id, child, params ?? {}] as const,

  /** Identity is its own root so a logout can clear it independently. */
  me: () => ['me'] as const,
  dashboard: () => ['dashboard'] as const,
  notifications: () => ['notifications'] as const,
} as const;
